import { apiBase } from "@/api/instance";
import Qs from "qs";

export const SearchBrand = (params) => {
  return apiBase({
    url: `/cats/branches`,
    method: "get",
    params: params,
    paramsSerializer: (params) => {
      return Qs.stringify(params, { arrayFormat: "repeat" });
    },
  });
};

export const UploadImage = (formData) => {
  return apiBase({
    url: "/images/upload",
    method: "post",
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const StoreBrand = (params) => {
  return apiBase({
    url: "/cats/branches",
    method: "post",
    data: params,
  });
};

export const ShowBrand = ({ id }) => {
  return apiBase({
    url: `/cats/branches/${id}`,
    method: "get",
  });
};

export const UpdateBrand = (params) => {
  return apiBase({
    url: `/cats/branches/${params.id}`,
    method: "put",
    data: params,
  });
};

export const DestroyBrand = ({ id }) => {
  return apiBase({
    url: `/cats/branches/${id}`,
    method: "delete",
  });
};
